import { AVT_SIZE } from '../constant/numericParams';
import Resizer from 'react-image-file-resizer';

export const resizeFile = async ({
  file,
  maxWidth = AVT_SIZE,
  maxHeight = AVT_SIZE,
  compressFormat = 'PNG',
  quality = 100,
}: {
  file: any;
  maxWidth?: number;
  maxHeight?: number;
  compressFormat?: string;
  quality?: number;
  outputType?: string;
}) => {
  return await new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      maxWidth,
      maxHeight,
      compressFormat,
      quality,
      0,
      (uri: any) => {
        resolve(uri);
      },
      'base64'
    );
  });
};
